import React from 'react';
import Header from './components/Header';
import Banner from './components/Banner';
import About from './components/About';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Banner />
      <About />
      <WhyChooseUs />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
